export default __webpack_public_path__ + "static/media/about3.a8dd6e3c.svg";